/**
 * Cài đặt hệ thống – Chánh án. Cấu trúc rõ cho nhà đầu tư.
 */
import { Box, Typography, Paper, List, ListItem, ListItemIcon, ListItemText, Divider } from '@mui/material'
import { Settings, Notifications, Security, People } from '@mui/icons-material'

const SECTIONS = [
  {
    icon: <Settings />,
    title: 'Cấu hình chung',
    description: 'Tham số hệ thống, định dạng mã vụ án, múi giờ và ngôn ngữ hiển thị.',
  },
  {
    icon: <Notifications />,
    title: 'Thông báo & Cảnh báo',
    description: 'Bật/tắt thông báo theo từng loại sự kiện, hạn nộp tạm ứng, nhắc lịch phiên.',
  },
  {
    icon: <Security />,
    title: 'Bảo mật & Phân quyền',
    description: 'Quản lý vai trò, quyền truy cập theo chức năng và theo đơn vị.',
  },
  {
    icon: <People />,
    title: 'Quản lý người dùng',
    description: 'Danh sách Thẩm phán, Thư ký; gán đơn vị, tài khoản đăng nhập.',
  },
]

export default function SettingsPage() {
  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h5" fontWeight={600} gutterBottom>
        Cài đặt hệ thống
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Cấu hình dành cho Chánh án: tham số vận hành, thông báo, phân quyền và quản lý người dùng.
      </Typography>

      <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
        <List disablePadding>
          {SECTIONS.map((sec, i) => (
            <Box key={sec.title}>
              {i > 0 && <Divider />}
              <ListItem sx={{ py: 2 }}>
                <ListItemIcon sx={{ color: 'primary.main', minWidth: 40 }}>{sec.icon}</ListItemIcon>
                <ListItemText
                  primary={sec.title}
                  secondary={sec.description}
                  primaryTypographyProps={{ fontWeight: 600 }}
                  secondaryTypographyProps={{ variant: 'body2', color: 'text.secondary' }}
                />
                <Typography variant="body2" color="primary" sx={{ cursor: 'pointer' }}>Mở cấu hình</Typography>
              </ListItem>
            </Box>
          ))}
        </List>
      </Paper>
    </Box>
  )
}
